/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonButton from "components/ArgonButton";
import { AdminUnreadBadge } from "components/AdminUnread";

import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";

import { Link } from "react-router-dom";

const ProductEnqTableData = (productEnqs, handleDeleteClick, refreshData) => ({
  columns: [
    { name: "sno", align: "center" },
    { name: "User Name", align: "left" },
    { name: "Product Name", align: "left" },
    { name: "Image Banner", align: "left" },
    { name: "Price Normal", align: "center" },
    { name: "Discount Price", align: "center" },
    { name: "Action", align: "center" },
  ],

  rows: productEnqs.map((enq, index) => {
    const isUnread = Boolean(enq.adminUnread);

    return {
      sno: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {index + 1}
        </ArgonTypography>
      ),
      "User Name": (
        <ArgonBox display="flex" alignItems="center" gap={0.75}>
          <ArgonTypography
            variant="caption"
            color={isUnread ? "error" : "text"}
            fontWeight={isUnread ? "bold" : "medium"}
          >
            {enq.userName || "N/A"}
          </ArgonTypography>
          <AdminUnreadBadge unread={isUnread} />
        </ArgonBox>
      ),
      "Product Name": (
        <ArgonTypography
          variant="caption"
          color={isUnread ? "error" : "text"}
          fontWeight={isUnread ? "bold" : "medium"}
        >
          {enq.productName || "N/A"}
        </ArgonTypography>
      ),
      "Image Banner": (
        <ArgonAvatar
          src={enq.imageBanner}
          alt={enq.productName || "Product"}
          size="sm"
          variant="rounded"
          sx={{
            border: isUnread ? "2px solid #f5365c" : "none",
          }}
        />
      ),
      "Price Normal": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          Rs. {enq.priceNormal || 0}
        </ArgonTypography>
      ),
      "Discount Price": (
        <ArgonTypography variant="caption" color="success" fontWeight="medium">
          Rs. {enq.discountPrice || 0}
        </ArgonTypography>
      ),
      Action: (
        <ArgonBox display="flex" alignItems="center" gap={0}>
          <ArgonButton
            variant="text"
            size="large"
            sx={{
              minWidth: "32px",
              p: 0,
              borderRadius: "50%",
              backgroundColor: isUnread ? "rgba(245, 54, 92, 0.1)" : "transparent",
              "&:hover": {
                backgroundColor: isUnread ? "rgba(245, 54, 92, 0.18)" : "transparent",
              },
            }}
            component={Link}
            to={`/product/viewproductenq/${enq._id}`}
          >
            <VisibilityIcon color={isUnread ? "error" : "primary"} />
          </ArgonButton>
          <ArgonButton
            variant="text"
            size="large"
            sx={{ minWidth: "32px", p: 0 }}
            onClick={() => handleDeleteClick(enq._id)}
          >
            <DeleteIcon color="error" />
          </ArgonButton>
        </ArgonBox>
      ),
    };
  }),
});

export default ProductEnqTableData;
